export default "__VITE_ASSET__CFBdtMzA__"